import solsvc from './solsvc'
import infinov from './infinov'

const overrides = {
  solsvc,
  infinov,
}

export default overrides
